export default {
  title: 'Urmărește comanda',
};
